export type Market = {
  name?: string;
  code?: string;
  lang?: string;
  href?: string;
  canonical_url?: string;
  telephone?: string;
  email: string;
  socialHandles?: {
    twitter?: string;
    facebook?: string;
    instagram?: string;
    youtube?: string;
    linkedin?: string;
  };
  slugPrefix?: string;
};

export type Markets = {
  currentMarket: Market;
  allMarkets: { [marketKey: string]: Market };
};

export const allMarkets: { [key: string]: Market } = {
  AU: {
    name: "Australia",
    code: "AU",
    lang: "en-AU",
    href: "https://www.vinomofo.com",
    canonical_url: "https://www.vinomofo.com",
    telephone: "1800 663 419",
    email: "team@vinomofo.com",
    socialHandles: {
      facebook: "@vinomofo",
      twitter: "@vinomofo",
      linkedin: "@vinomofo",
      instagram: "@vinomofo",
      youtube: "@vinomofo",
    },
    slugPrefix: "/au",
  },
  SG: {
    name: "Singapore",
    code: "SG",
    lang: "en-SG",
    href: "https://www.vinomofo.com.sg",
    canonical_url: "https://www.vinomofo.com",
    telephone: "3165 6889",
    email: "team@vinomofo.com",
    socialHandles: {
      facebook: "@vinomofo",
      twitter: "@vinomofo_sg",
      linkedin: "@vinomofo",
      instagram: "@vinomofo",
      youtube: "@vinomofo",
    },
    slugPrefix: "/sg",
  },
};

export const useMarket = (): Markets => {
  const currentMarket = allMarkets[process.env.GATSBY_VM_MARKET || "AU"];

  return {
    currentMarket,
    allMarkets,
  };
};
